import { useContext } from 'react';
import ResourceContext from 'src/contexts/ResourceContext';

const useCurrentResource = () => useContext(ResourceContext);

export default useCurrentResource;
